module.exports = __webpack_public_path__ + "static/media/5_yeah-your-fighting-the-cavity-monster.52780a6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/5_yeah-your-fighting-the-cavity-monster.mp3
// module id = 4uFw
// module chunks = 0